<h2>
  Plaatsing
  <span
    class=" black"
    *ngIf="someProductsExecuted && earliestExecutionDate != null"
  >
    - uitgevoerd ({{ earliestExecutionDate | date: 'dd/MM/yyyy' }})
  </span>
  <span
    class=" black"
    *ngIf="!someProductsExecuted && earliestPlacementDate != null"
  >
    - plaatsing ({{ earliestPlacementDate | date: 'dd/MM/yyyy' }})
  </span>
</h2>
